import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreativeFormatCreativeType } from '../../../generated/graphql';
import { SPACING_UNIT } from '../../constant/spacing';
import CreativeFormatCreativeTypeIcon from './CreativeFormatCreativeTypeIcon';

type Props = {
  creativeType: Pick<CreativeFormatCreativeType, 'key' | 'name'>;
  className?: string;
};

const CreativeFormatCreativeTypeLabel: FC<Props> = ({ creativeType, className }) => (
  <Root className={className}>
    <Icon creativeType={creativeType} />
    <Typography noWrap>
      <FormattedMessage id={`creative_format.creative_type.${creativeType.key}`} />
    </Typography>
  </Root>
);

const Root = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
});

const Icon = styled(CreativeFormatCreativeTypeIcon)({
  marginRight: SPACING_UNIT,
});

export default CreativeFormatCreativeTypeLabel;
